export default __webpack_public_path__ + "static/media/paging_prev_B.e16fecae.svg";